import React from 'react';

export interface ILoaderProps {
    width?: number;
    height?: number;

}


export const Loader = ({ width, height }: ILoaderProps) => {
    const _width = width ?? 50;
    const _height = height ?? 50;
    return(
    
       
<div className="loader"

style={{
    height: _height,
    width: _width,
}}
></div>

    );
};
